import determineAchievementAmt from "./determine_achievement_amt";
import compareAmounts from "./compare_amounts";
import checkAchieveUnlockedFeatures from "../../components/game-views/objectsStatus/check_achieve_unlocked_features";

export const processAchievementCriteriaArr = (criteriaArr, processType, gameData,
        savingsInfo, creditCardBalance, summaryInvestments, investmentMaster,
        nbrMonthsPlayed, creditScore, moneyMgmtTestArr, creditCardActive, investmentActive,
        unlockedFeatures) => {
    let checkAmount = 0;
    let checkAmountArr = [];
    for (let i=0; i<criteriaArr.length; i++){
        const criteria = criteriaArr[i];
        let pctBase = 0;
        if (criteria.pctBase){
            pctBase = criteria.pctBase;
        }
        let checkAmountObj = determineAchievementAmt(criteria.dataName, gameData.currentCash,
                savingsInfo, creditCardBalance, summaryInvestments, investmentMaster,
                gameData.assetTable, gameData.expenseTable, gameData.loanTable, nbrMonthsPlayed, 
                gameData.gameNbrMonths, creditScore, gameData.currentGameDate, gameData.currentMoodPoints,
                gameData.badgesEarned, moneyMgmtTestArr, pctBase);
        checkAmount = checkAmountObj.checkAmount;
        let criteriaAmount = criteria.amount;
        if (checkAmountObj.pctBaseAmt !== "N/A"){
            criteriaAmount = (+checkAmountObj.pctBaseAmt * +criteria.amount) / 100; 
        }
        let earnedAchievement = false;
        if (checkAmount !== "N/A"){
            earnedAchievement = compareAmounts(criteriaAmount, criteria.operation, checkAmount);
        }
        checkAmountObj = {...checkAmountObj, earnedAchievement: earnedAchievement};
        if (processType === "getText"){
            let bankSavingsActive = false;
            let retirementSavingsActive = false;
            if (savingsInfo.currentlyActive & savingsInfo.currentlyActive === true){
                 for (let j=0; j<savingsInfo.savingsArr.length; j++){
                       let savingsClass = savingsInfo.savingsArr[j].savingsClass;
                       if (savingsClass === "bank"){
                            bankSavingsActive = true;
                       }
                       if (savingsClass === "retirement"){
                            retirementSavingsActive = true;
                       }
                       if (bankSavingsActive === true && retirementSavingsActive === true){
                            break;
                       }
                 }
            }
            const unlockedFeaturesObj = checkAchieveUnlockedFeatures(criteria.dataName, unlockedFeatures,
                bankSavingsActive, retirementSavingsActive, creditCardActive, investmentActive )
            checkAmountObj = {...checkAmountObj, unlockedFeaturesObj: unlockedFeaturesObj, 
                criteria: criteria, criteriaAmount: criteriaAmount };
        }
        checkAmountArr.push(checkAmountObj);
    }
 
    return checkAmountArr;
}
export default processAchievementCriteriaArr;